import type { OnInit } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { Auth } from '@freelancer/auth';
import { Pwa } from '@freelancer/pwa';
import type { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'fl-language-switcher',
  template: `
    @if (!(isLoggedIn$ | flAsync)) {
      <fl-language-switcher-link [isLoggedIn]="false" />
    } @else {
      @if (!forceInlineSwitcher) {
        <fl-language-switcher-link
          class="mobile:hide"
          [isLoggedIn]="true"
        ></fl-language-switcher-link>
      }
      <!-- this is not an "*ngIf" because we can show either when they are not forced -->
      <fl-language-switcher-inline
        [compact]="compact"
        [class.desktop:hide]="!forceInlineSwitcher"
        [class.tablet:hide]="!forceInlineSwitcher"
      ></fl-language-switcher-inline>
    }
  `,
  styleUrls: ['./language-switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSwitcherComponent implements OnInit {
  private auth = inject(Auth);
  private pwa = inject(Pwa);

  /**
   * Whether or not to attach a label to the inline switcher
   **/
  @Input() compact = false;

  /**
   * Whether or not the switcher is disabled entirely.
   */
  disabled: Promise<boolean>;

  /**
   * Whether or not to force the inline language switcher.
   * Toggling this off will enable the link-based switcher on desktop
   **/
  forceInlineSwitcher: boolean;

  /**
   * Whether or not the user is logged in.
   * Display link version if logged out.
   */
  isLoggedIn$: Observable<boolean>;

  ngOnInit(): void {
    this.isLoggedIn$ = this.auth.isLoggedIn();

    this.forceInlineSwitcher =
      // installed mode always sees the inline switcher
      this.pwa.isInstalled();
  }
}
